import { render, staticRenderFns } from "./freight.vue?vue&type=template&id=11df5285&scoped=true"
import script from "./freight.vue?vue&type=script&lang=js"
export * from "./freight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11df5285",
  null
  
)

export default component.exports